<template>
  <page :name="_t('Dati aziendali')">
    <pf-page-section>
      <pf-card v-if="login.has_recurring_payments || login.verificato">
        <pf-card-header>
          <pf-title h="3">{{ _t('Modalità di pagamento') }}</pf-title>
        </pf-card-header>
        <pf-card-body v-if="login.has_recurring_payments">
          {{ $t('Pagamenti ricorrenti attivi. Tutte le prossime fatture verranno saldate automaticamente.') }}
          <pf-button variant="danger" small :disabled="!login.grants.billing || sendingRecurringPayments" @click="disableRecurringPayments">
            {{ $t("Disattiva") }}
          </pf-button>
        </pf-card-body>

        <pf-card-body v-else-if="login.verificato">
          <pf-icon status="warning"><triangle-exclamation-icon /></pf-icon>
          {{ $t('Pagamenti ricorrenti non attivi. Per attivarli spunta la relativa opzione quando effettuerai il prossimo pagamento di un ordine o di una fattura.') }}
        </pf-card-body>
      </pf-card>
    </pf-page-section>

    <pf-page-section>
      <pf-title h="2">{{ $t('Modalità e dati di fatturazione') }}</pf-title>
      <billing-form style="max-width: 800px;"/>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import BillingForm from '../components/billing-form.vue';
import { useLoginStore } from '@/store/login';
import { useAlertStore } from '@/store/alerts';
import { CompanyResource } from '@/resources';
import { ref } from 'vue';
import { $t as _t } from '@/i18n';
import TriangleExclamationIcon from '@vue-patternfly/icons/triangle-exclamation-icon';

defineOptions({
  name: 'CompanyPage',
});

const login = useLoginStore();
const alert = useAlertStore();

const sendingRecurringPayments = ref(false);

async function disableRecurringPayments() {

  if (login.id_azienda === null || !confirm(_t('Sei sicuro di voler disattivare i pagamenti ricorrenti automatici?'))) {
    return;
  }

  sendingRecurringPayments.value = true;
  try {
    await new CompanyResource().save(login.id_azienda, {
      disableRecurringPayments: true,
    });
    alert.add({ title: _t('Pagamenti automatici disattivati'), type: 'success', toast: true });
    await login.refresh();
  } finally {
    sendingRecurringPayments.value = false;
  }
}
</script>
